import { NgIf, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomAssetImage } from '@shared/shared/interfaces/custom-assets.interfaces';
import { CardRibbonComponent } from '@shared/shared/modules/card/components/card-ribbon/card-ribbon.component';
import { FollowButtonComponent } from '@shared/shared/modules/card/components/follow-button/follow-button.component';
import { CardRibbon, FollowButton } from '@shared/shared/modules/card/models/card';
import * as fromGlobalStore from '@shared/store';
import { filter, take } from 'rxjs';

export interface InterestCard {
  name: string;
  imageUrl: string;
  followButton: FollowButton;
}

@Component({
  selector: 'ten-interest-card',
  templateUrl: './interest-card.component.html',
  styleUrls: ['../artist-card/artist-card.component.scss', './interest-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CardRibbonComponent, NgIf, NgStyle, FollowButtonComponent],
})
export class InterestCardComponent implements OnInit {
  @Input() public card: InterestCard;
  public image: string;
  constructor(private ngrxStore: Store<any>) {}

  public ribbonData = {
    attraction: 'SideFilterComponent:TitleAttraction',
    general: 'Preferences:GeneralTag',
    music: 'SideFilterComponent:TitleMusic',
    sport: 'SideFilterComponent:TitleSports',
    theatre: 'SideFilterComponent:TitleTheatre',
    comedy: 'SideFilterComponent:TitleComedy',
    travel: 'Preferences:TravelTag',
  };

  public ngOnInit() {
    this.ngrxStore
      .select(fromGlobalStore.getSpecificCustomAsset, { customAsset: 'default_image_for_artists_in_preferences' })
      .pipe(
        filter((images: any) => Array.isArray(images)),
        take(1)
      )
      .subscribe((images: Array<CustomAssetImage>) => {
        if (!images.length) {
          this.image = 'assets/images/preferences/artist-thumbnail-icon.png';
        } else {
          this.image = images[0]?.file;
        }
      });
  }

  public getRibbon(category: string): CardRibbon {
    return { text: this.ribbonData[category] };
  }
}
